<template>
  <div class="v3-popup save-confirm-popup" v-if="visible">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content small">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title">{{ langData.editSaveTip }}</div>
      <div class="v3-popup-content-footer">
        <div class="confirm-btn btns" @click="confirmSave">{{ langData.saveConfirm }}</div>
        <div class="cancel-btn btns" @click="cancelSave">{{ langData.saveCancel }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LanguageHook from "@/hooks/language";

const { langData } = LanguageHook();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:visible", "confirm", "cancel"]);

const handleClose = () => {
  emit("update:visible", false);
};

const confirmSave = () => {
  emit("confirm");
  emit("update:visible", false);
};

const cancelSave = () => {
  emit("cancel");
  emit("update:visible", false);
};
</script>

<style scoped lang="less"></style>
